"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _core = require("@material-ui/core");
var _clsx = _interopRequireDefault(require("clsx"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var CustomDropdownMenu = function CustomDropdownMenu(_ref) {
  var classes = _ref.classes,
    handleClick = _ref.handleClick,
    dropDownElements = _ref.dropDownElements,
    externalLinksFlag = _ref.externalLinksFlag,
    linkText = _ref.linkText,
    externalLinks = _ref.externalLinks;
  return /*#__PURE__*/_react.default.createElement(_core.Paper, {
    className: classes.paper
  }, /*#__PURE__*/_react.default.createElement("div", {
    id: "aboutDropDown"
  }, dropDownElements.map(function (dropDownElementsItem) {
    return /*#__PURE__*/_react.default.createElement(_reactRouterDom.HashRouter, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.NavLink, {
      className: dropDownElementsItem.sublink ? (0, _clsx.default)(classes.sublink, classes.link) : classes.link,
      activeStyle: dropDownElementsItem.linkActiveStyle ? {
        color: dropDownElementsItem.linkActiveStyle
      } : {
        color: '#27DBFF'
      },
      to: dropDownElementsItem.link,
      onClick: handleClick
    }, dropDownElementsItem.labelText));
  }), externalLinksFlag && externalLinks[linkText] ? externalLinks[linkText].map(function (link) {
    return /*#__PURE__*/_react.default.createElement("a", {
      href: link.link,
      rel: "noreferrer",
      target: "_blank",
      className: classes.link
      // TODO: find out use of activeStyle, If not used please remove.
      // eslint-disable-next-line react/no-unknown-property
      ,

      activeStyle: {
        color: '#27DBFF'
      }
    }, link.title);
  }) : null));
};
var styles = function styles() {
  return {
    paper: function paper(props) {
      var defaultProps = {
        background: '#142D64',
        width: '170px',
        padding: '0px 16px 18px 22px',
        position: 'absolute',
        margin: '-5px 0px 0px 18px',
        borderRadius: '0'
      };
      return Object.assign(defaultProps, props.navBarstyling ? props.navBarstyling.dropdownMenu ? props.navBarstyling.dropdownMenu.paper : {} : {});
    },
    sublink: function sublink(props) {
      var defaultProps = {
        fontWeight: '500 !important'
      };
      return Object.assign(defaultProps, props.navBarstyling ? props.navBarstyling.dropdownMenu ? props.navBarstyling.dropdownMenu.sublink : {} : {});
    },
    link: function link(props) {
      var defaultProps = {
        textDecoration: 'none',
        color: 'white',
        fontFamily: 'Lato',
        fontSize: '15px',
        fontWeight: '800',
        lineHeight: '12px',
        display: 'block',
        marginTop: '13px',
        '&:hover': {
          cursor: 'pointer',
          color: '#41A7FF'
        }
      };
      return Object.assign(defaultProps, props.navBarstyling ? props.navBarstyling.dropdownMenu ? props.navBarstyling.dropdownMenu.link : {} : {});
    }
  };
};
CustomDropdownMenu.defaultProps = {
  classes: {},
  statsStyling: {}
};
var _default = (0, _core.withStyles)(styles)(CustomDropdownMenu);
exports.default = _default;